import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: Array<RouteConfig> = [
  {
    path: "/talents",
    name: "talents",
    component: safeImport(
      () =>
        import(/* webpackChunkName: "route.talents" */ "@/views/Talents.vue")
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/talents/lists",
    name: "talents_lists",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.talents.lists" */ "@/views/TalentLists.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/talents/lists/:listHash",
    name: "talents_lists_detail",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.talents.lists.detail" */ "@/views/TalentListDetail.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
